module.exports = __webpack_public_path__ + "img/CZ.b5a4b286.svg";